/*
Copyright 2022 Fondazione Bruno Kessler
Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
except in compliance with the Licence.

You may obtain a copy of the Licence at:
http://ec.europa.eu/idabc/eupl.html

Unless required by applicable law or agreed to in writing, software distributed under 
the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF 
ANY KIND, either express or implied. See the Licence for the specific language 
governing permissions and limitations under the Licence.
*/
import {HttpClient} from "@angular/common/http";
import {ChangeDetectorRef, Component, Inject, Input, OnInit} from "@angular/core";
import {CommonState} from "@app/store/common/common.state";
import {ModalController} from "@ionic/angular";
import {DoctorPanelActions} from "@modules/doctor-panel/store/doctor-panel.actions";
import {DoctorPanelState} from "@modules/doctor-panel/store/doctor-panel.state";
import {hasActionsExecuting} from "@ngxs-labs/actions-executing";
import {Select, Store} from "@ngxs/store";
import {Icd9} from "@trec/api";
import {C3SnackbarStatusService} from "@trec/components/snackbar-status";
import {Observable} from "rxjs";

@Component({
  selector: "app-edit-icd9-dialog",
  templateUrl: "./edit-icd9-dialog.component.html",
  styleUrls: ["./edit-icd9-dialog.component.scss"],
  standalone: false
})
export class EditIcd9DialogComponent implements OnInit {
  @Input()
  icd9Code: any;
  @Input()
  context: any;
  @Input()
  icd9Description: any;

  @Select(hasActionsExecuting([DoctorPanelActions.FetchIcd9List]))
  loading$: Observable<boolean>;

  codiceIcd9;
  listaCodiciIcd9: Icd9[];
  selectedIcd9: Icd9 | null;

  //description: boolean = false;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    private store: Store,
    private cd: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private c3Snackbar: C3SnackbarStatusService
  ) { }

  ngOnInit(): void {
    if (this.icd9Code !== "n/d" && this.icd9Code) {
      this.selectedIcd9 = {id: this.icd9Code, description: this.icd9Description};
      this.codiceIcd9 = this.codiceIcd9;
    } else {
      this.selectedIcd9 = null;
    }
  }

  fetchListCodici() {
    //if (!this.description) {
    this.store.dispatch(new DoctorPanelActions.FetchIcd9List(this.codiceIcd9, false, false));
    this.store.select(DoctorPanelState.icd9List).subscribe((list) => {
      this.listaCodiciIcd9 = list;
    });
    //}
    /*if (this.description) {
      this.store.dispatch(new DoctorPanelActions.FetchIcd9List(this.codiceIcd9, false, true));
      this.store.select(DoctorPanelState.icd9List).subscribe((list) => {
        this.listaCodiciIcd9 = list;
      });
    }*/
  }

  onQuickFilterChange(value: string | Icd9) {
    if (typeof value === "string" && value.length >= 3) {
      this.fetchListCodici();
    } else if (typeof value !== "string") {
      this.onIcd9Selected(value);
    }
  }

  onIcd9Selected(code: Icd9 | null = null) {
    this.selectedIcd9 = code;
    this.codiceIcd9 = "";
    this.cd.markForCheck();
  }

  onSubmit() {
    let patientId = this.store.selectSnapshot(CommonState.patientId)!;
    let icd9 = this.selectedIcd9 ? this.selectedIcd9!.id : "";
    let context = this.context;

    this.store.dispatch(new DoctorPanelActions.UpdateIcd9(context, icd9, patientId)).subscribe(
      () => {
        this.c3Snackbar.showSuccess({message: `Codice ICD-9 modificato correttamente`});
        this.modalCtrl.dismiss(this.selectedIcd9);
      },
      (err) => {
        this.c3Snackbar.showError(err);
      }
    );
  }

  /*toggle(checked: boolean) {
    this.description = checked;
    this.cd.markForCheck();
  }*/

  onClose() {
    this.modalCtrl.dismiss();
  }
}
